module.exports = __webpack_public_path__ + "img/stock4.44682126.png";